export default __webpack_public_path__ + "static/media/maya-1.86aae596.jpg";